import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { getVerottajailmoitettavaProjectIds } from '../services/getVerottajailmoitettavaProjectIds.service';
import { getProjectsActivityFilterCacheKey } from '../utils/getProjectsActivityFilterCacheKey';

export const VEROTTAJAILMOITETTAVA_SOURCE_KEYS = {
  unsentFilings: 'unsentFilings',
  externalResources: 'externalResources',
  subcontractorInvoices: 'subcontractorInvoices',
};

const SOURCE_API_PATHS = {
  [VEROTTAJAILMOITETTAVA_SOURCE_KEYS.unsentFilings]:
    'user/projects/verottajailmoitettava-project-ids/from-unsent-filings',
  [VEROTTAJAILMOITETTAVA_SOURCE_KEYS.externalResources]:
    'user/projects/verottajailmoitettava-project-ids/from-external-resources',
  [VEROTTAJAILMOITETTAVA_SOURCE_KEYS.subcontractorInvoices]:
    'user/projects/verottajailmoitettava-project-ids/from-subcontractor-invoices',
};

const createSourceThunk = (sourceKey) =>
  createAsyncThunk(
    `projects/loadVerottajailmoitettavaProjectIds/${sourceKey}`,
    async (arg = {}, { getState }) => {
      const activeEmployerInfo =
        arg.activeEmployerInfo || selectUserActiveEmployerInfo(getState());
      const cacheKey = getProjectsActivityFilterCacheKey(activeEmployerInfo);

      const projectIds = await getVerottajailmoitettavaProjectIds({
        apiPath: SOURCE_API_PATHS[sourceKey],
        activeEmployerInfo,
      });

      return {
        cacheKey,
        sourceKey,
        projectIds,
      };
    },
    {
      condition: (arg = {}, { getState }) => {
        const state = getState();
        const activeEmployerInfo =
          arg.activeEmployerInfo || selectUserActiveEmployerInfo(state);
        const cacheKey = getProjectsActivityFilterCacheKey(activeEmployerInfo);

        if (!cacheKey) {
          return false;
        }

        const requestStatus =
          state.projects.verottajailmoitettavaProjectIdsRequestStatusByEmployer?.[
            cacheKey
          ]?.[sourceKey];

        if (requestStatus === 'pending') {
          return false;
        }

        if (arg.force || arg.shouldRefetch) {
          return true;
        }

        return requestStatus !== 'fulfilled';
      },
    }
  );

export const loadVerottajailmoitettavaProjectIdsFromUnsentFilings =
  createSourceThunk(VEROTTAJAILMOITETTAVA_SOURCE_KEYS.unsentFilings);
export const loadVerottajailmoitettavaProjectIdsFromExternalResources =
  createSourceThunk(VEROTTAJAILMOITETTAVA_SOURCE_KEYS.externalResources);
export const loadVerottajailmoitettavaProjectIdsFromSubcontractorInvoices =
  createSourceThunk(VEROTTAJAILMOITETTAVA_SOURCE_KEYS.subcontractorInvoices);

export const VEROTTAJAILMOITETTAVA_SOURCE_THUNKS = [
  loadVerottajailmoitettavaProjectIdsFromUnsentFilings,
  loadVerottajailmoitettavaProjectIdsFromExternalResources,
  loadVerottajailmoitettavaProjectIdsFromSubcontractorInvoices,
];
